import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Menu, Avatar, Switch } from 'antd';
import { ThemeContext } from '../../context/themeProvider';
import { useDispatch, useSelector } from 'react-redux';
import { MANAGE_PROFILE, PUBLIC_DEFAULT_ROUTE, SETTINGS_ROUTE } from '../../constants/common';
import { userLogout } from '../../utils/common';
import ThemeChangeSettings from '../../pages/Settings/ThemeChangeSettings';
import { setIsAutoCollapseLeftbar } from '../../features/organization/organizationSlice';

const UserDropdownMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, userPermissions } = useSelector((state) => state.user);
  const { changeBackgroundTheme } = useContext(ThemeContext);
  const [isdarkMode, setIsdarkMode] = useState(localStorage.getItem('mainTheme') === 'dark');
  const isAutoCollapseLeftbar = useSelector((state) => state.organization?.isAutoCollapseLeftbar);

  useEffect(() => {
    const isAutoCollapse = localStorage.getItem('isAutoCollapseLeftbar');
    if (isAutoCollapse === 'true') {
      dispatch(setIsAutoCollapseLeftbar(true));
    }
  }, []);

  const toggleTheme = () => {
    setIsdarkMode(!isdarkMode);
  };

  useEffect(() => {
    if (isdarkMode) {
      localStorage.setItem('mainTheme', 'dark');
    } else {
      localStorage.setItem('mainTheme', 'light');
    }
    changeBackgroundTheme(isdarkMode);
  }, [isdarkMode]);
  const menu = (
    <Menu>
      <Menu.Item key="user-email">{user?.email}</Menu.Item>
      <Menu.Item key="settings" onClick={() => navigate(`${SETTINGS_ROUTE}${MANAGE_PROFILE}`)}>
        Profile
      </Menu.Item>
      <Menu.Item
        key="auto-collapse-leftbar"
        onClick={() => dispatch(setIsAutoCollapseLeftbar(!isAutoCollapseLeftbar))}
        style={{ width: '200px' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span> Auto Collapse Leftbar</span>
          <Switch
            size="small"
            checked={isAutoCollapseLeftbar}
            onChange={() => dispatch(setIsAutoCollapseLeftbar(!isAutoCollapseLeftbar))}
          />
        </div>
      </Menu.Item>
      <Menu.Item key="theme-settings">
        <div
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
          onClick={(e) => e.stopPropagation()}
        >
          <span
            style={{ flex: 1, cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault();
              const colorPickerButton = e.currentTarget.parentElement.querySelector('.theme-color-picker button');
              if (colorPickerButton) {
                colorPickerButton.click();
              }
            }}
          >
            Theme Color
          </span>
          <div className="theme-color-picker">
            <ThemeChangeSettings onClose={() => document.body.click()} />
          </div>
        </div>
      </Menu.Item>
      <Menu.Item
        key="logout"
        onClick={async () => {
          const resp = await userLogout();
          if (resp) {
            navigate(PUBLIC_DEFAULT_ROUTE);
          }
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const getText = () => {
    if (userPermissions?.name) {
      return userPermissions?.name.charAt(0).toUpperCase();
    }

    if (userPermissions?.email) {
      return userPermissions?.email.charAt(0).toUpperCase();
    }

    return 'U';
  }; // Default to "U" if no username

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
      <Avatar size="large" style={{ cursor: 'pointer', marginRight: '3px' }}>
        {getText()}
      </Avatar>
    </Dropdown>
  );
};

export default UserDropdownMenu;
